import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/Home.css';

function Home() {

  let navbarRef = React.useRef(null);


  return (
    <div>
      <Navbar ref={navbarRef} />
     {/* Hero Section */}
<header className="hero-section">
  <video
    autoPlay
    muted
    loop
    className="background-video"
    playsInline
    onCanPlayThrough={(e) => e.target.style.opacity = 1}
    style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }}
  >
    <source src="/background-video.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="hero-content">
    <h1 className="hero-title">Welcome to Legal Trails</h1>
    <p className="hero-subtitle">Empowering Your Legal Journey</p>
    <button
      className="cta-button"
      onClick={() =>
        document.getElementById('about').scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    >
      Get Started
    </button>
  </div>
</header>


{/* About Section */}
<section id="about" className="about-section">
  <div className="about-container">
    <div className="about-content">
      <h2>About Us</h2>
      <p>
        Legal Trails (Firm) is a full-service law practice founded by a seasoned and highly respected attorney.
        Our firm is youthful, determined, effective, and enthusiastic. We are passionately committed to serving
        the interests of our clients, and we place great importance on collaboration. We make it a priority to
        deeply understand our clients' businesses to offer tailored legal advice.
      </p>
      <p>
        We aim to protect our clients' rights and achieve the best possible outcomes in legal, corporate,
        or financial matters. We emphasize professionalism, responsiveness, creativity, and teamwork to
        provide efficient and cost-effective legal solutions.
      </p>
      <p>
        Our expert team of lawyers, chartered accountants, and professionals have an excellent
        reputation across a wide range of legal fields, including family law, civil law, criminal law, 
        consumer cases, real estate matters, trademark cases, arbitration, corporate law, commercial law and more.
        We are adept in handling complex legal matters, advising on family disputes, property issues,
        entry strategies, risk management, and legal documentation.
      </p>
      <p>
      At Legal Trails, we prioritize professionalism, responsiveness, creativity, and teamwork to deliver efficient, cost-effective, and innovative legal solutions that protect our clients' rights and achieve optimal outcomes."
      </p>
      
    </div>
    <div className="about-image">
      <img src="https://images.pexels.com/photos/8731032/pexels-photo-8731032.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="About Us" />
    </div>
  </div>
</section>

{/* Why Choose Us Section */}
<section className="why-choose-us-section">
  <div className="why-choose-us-container">
    <div className="why-choose-us-content">
      <h2>Why Choose Us?</h2>
      <p>
      At Legal Trails, client satisfaction is the cornerstone of our firm’s work ethic. We are committed to delivering exceptional legal services by upholding the highest standards of professionalism, integrity, and diligence in every matter we handle. Our approach is built on the core values of accessibility, transparency, quality, and responsiveness, ensuring a proactive and results-driven strategy at every stage of our service.

      </p>
      <p>
      We adhere to well-defined client service standards, maintaining excellence in engagement, communication, reporting, documentation, and billing.
      </p>
      <p><b>Our comprehensive legal services include:</b></p>

      <ul>
        <p><b>Legal Consultation</b> : Providing expert legal advice and information tailored to your needs.
        </p>
        <p><b>Document Review & Drafting</b> : Examining and drafting agreements, leases, wills, corporate documents, court pleadings, and other legal instruments.
        </p>
        <p><b>Alternative Dispute Resolution (ADR)</b> : Facilitating mediation, arbitration, and third-party dispute resolution.
Negotiation & Representation: Preparing legal documents and representing clients in negotiations to safeguard their interests.
</p>
        <p><b>Litigation & Advocacy</b> : Representing clients before courts, arbitration panels, and administrative tribunals.
        </p>
</ul>

      <p>
        <b>Our Edge: A Forward-Thinking Legal Partner</b> :
      

        <p>
          At Legal Trails, we don’t just resolve legal issues—we anticipate challenges and craft forward-looking solutions to protect and advance our clients’ interests. <b>Our firm is:</b> </p> 
      </p>
      <p>
        
      <ul>
      
        <p>
        <b>✔ Agile & Adaptive </b> – Navigating today’s complex legal and business environment with innovative problem-solving.
        </p>
        <p>
        <b>✔ Client-Centric </b>– Taking the time to understand both immediate concerns and long-term goals.
          </p>

        <p>
        <b>✔ Results-Driven </b>– Delivering tailored legal strategies that maximize success and mitigate risks.
        </p>

        <p>
        <b>✔ Ethical & Transparent </b>– Ensuring honest communication, clarity in billing, and adherence to the highest professional ethics.
</p>
      </ul>
      </p>
      <p>When you choose Legal Trails, you choose a legal partner that is relentless in advocacy, innovative in strategy, and unwavering in commitment. Let us help you navigate the legal landscape with confidence and clarity.
      </p>
      <p>
      <b>Your success is our mission. Your trust is our foundation.</b></p>
    </div>
    <div className="why-choose-us-image">
      <img
        src="https://factohr.com/wp-content/themes/factohr-theme/images/blog/Core%20Values/2-Infographic.png"
        alt="Why Choose Us?"
      />
    </div>
  </div>
</section>

{/* Services Section */}
<section className="services-section">
  <h2>Our Services</h2>
  <div className="services-container">
    <div className="service-card" onClick={() => window.dispatchEvent(new Event('expandServicesDropdown'))}>
      <div className="card-icon">⚖️</div>
      <h3>Legal Research and Advice</h3>
      <p>Expert consultation to tackle your legal challenges effectively.</p>
    </div>
    <div className="service-card" onClick={() => window.dispatchEvent(new Event('expandServicesDropdown'))}>
      <div className="card-icon">📜</div>
      <h3>Document Drafting</h3>
      <p>Comprehensive document review and drafting for your needs.</p>
    </div>
    <div className="service-card" onClick={() => window.dispatchEvent(new Event('expandServicesDropdown'))}>
      <div className="card-icon">🏛️</div>
      <h3>Court Representation</h3>
      <p>Professional representation to defend your case with confidence.</p>
    </div>
    <div className="service-card" onClick={() => window.dispatchEvent(new Event('expandServicesDropdown'))}>
      <div className="card-icon">💼</div>
      <h3>POSH Compliance</h3>
      <p>Ensuring a respectful and safe workplace with expert POSH training and compliance.</p>
    </div>
  </div>
</section>


<Footer />



    </div>
  );
}

export default Home;
